// Generated by scripts/build-ui-icons.mjs.
export { Play as default } from "../ui/glyphs-6";
